export function toggleShowDetails(
	data: { rowIndex: number },
	setRowDetailState: React.Dispatch<React.SetStateAction<number[]>>,
) {
	setRowDetailState((prev: number[]) => {
		if (prev.includes(data.rowIndex))
			return prev.filter((el) => el !== data.rowIndex);
		return [data.rowIndex];
	});
}
